<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  button {
    display: flex;
    flex-shrink: 0;

    cursor: pointer;

    align-items: center;
    justify-content: center;

    height: utils.in_rem(20px);
    width: utils.in_rem(20px);
    padding: utils.in_rem(2px);

    border: solid 2px colors.get(interfaceSwGrey_10);
    background-color: colors.get(interfaceWhite);
    color: colors.get(black_90);

    &.square {
      border-radius: 4px;
    }
    &.circle {
      border-radius: 44px;
    }

    &:focus {
      outline: solid 2px colors.get(primary_50);
    }

    &.checked,
    &.partial {
      background-color: colors.get(primary_50);
      border-color: colors.get(primary_50);
      color: colors.get(textWhite);

      &:hover {
        background-color: colors.get(primary_70);
        border-color: colors.get(primary_70);
      }

      &:focus {
        background-color: colors.get(primary_70);
        border-color: colors.get(primary_70);
        outline: solid 2px colors.get(primary_50);
      }
    }

    /* Add disabled styling */
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
      background-color: colors.get(interfaceSwGrey_10);
      border-color: colors.get(interfaceSwGrey_20);

      &.checked,
      &.partial {
        background-color: colors.get(interfaceSwGrey_20);
        border-color: colors.get(interfaceSwGrey_20);
        color: colors.get(interfaceWhite);

        &:hover {
          background-color: colors.get(interfaceSwGrey_20);
          border-color: colors.get(interfaceSwGrey_20);
        }
      }

      &:hover {
        background-color: colors.get(interfaceDisabledGrey_10);
        border-color: colors.get(interfaceSwGrey_20);
      }
    }
  }
</style>

<script>
  import Icon from "../../../../../svelte-design-system/components/atoms/Icon.svelte";

  export let checked = false;
  export let shape = "square";
  export let partial = false;
  export let runClick = true; // stops double counting clicks from ListItem
  export let disabled = false; // Add disabled prop

  let isHovered = false;

  let click = () => {
    if (!runClick || disabled) return; // Don't allow clicks when disabled
    checked = !checked;
    partial = false; // Can't be partial if clicked
  };

  let mouseenter = () => {
    if (!disabled) isHovered = true;
  };
  let mouseleave = () => {
    isHovered = false;
  };
  let focus = () => {
    if (!disabled) isHovered = true;
  };
  let blur = () => {
    isHovered = false;
  };

  let cls = "";
  export { cls as class };

  // We need a reactive variable here and not two Icon components,
  // otherwise the DOM thinks the Icon we've clicked is not on the dropdown
  // and the dropdown closes.
  let icon;
  $: if (partial) icon = "fa-regular fa-minus";
  else if ((checked || isHovered) && !disabled) icon = "fa-regular fa-check";
  else if (checked && disabled) icon = "fa-regular fa-check";
  else icon = "";
</script>

<button
  class="{cls} {shape}"
  class:checked
  class:partial
  on:click={click}
  on:mouseenter={mouseenter}
  on:mouseleave={mouseleave}
  on:focus={focus}
  on:blur={blur}
  {disabled}
  {...$$restProps}
>
  <Icon class={icon} size="small" />
</button>
